import { TitanButton } from "@lib/titan2/dist/game/control/TitanButton";
import { AbstractStakePanel } from "@lib/titan2/dist/game/view/display/AbstractStakePanel";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { GraphicsUtil } from "@lib/titan2/dist/util/view/GraphicsUtil";
import * as PIXI from "pixi.js";
import { SlingoEvent } from "../../../controller/event/SlingoEvent";
/**
 * StakeSelector.ts
 */
export class StakeSelector extends AbstractStakePanel {
    createProperties(landscapeProperties, portraitProperties) {
        super.createProperties(landscapeProperties, portraitProperties);
        this.landscapeProperties = landscapeProperties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
    }
    create() {
        super.create();
        Logger.addObjectRef(this, "StakeSelector");
    }
    open() {
        if (!this.isOpen) {
            super.open();
            this.isOpen = true;
            this.addPanelMask();
            this.handleOpenToggleComplete();
            this.callHandler(this.openHandler);
        }
    }
    close() {
        if (this.isOpen) {
            super.close();
            this.isOpen = false;
            this.toggleButton.setSelected(false);
            this.toggleButton.setEnabled(this.isEnabled);
            this.addPanelMask();
            this.handleCloseToggleComplete();
            this.callHandler(this.closeHandler);
        }
        else {
            this.handleCloseToggleComplete();
        }
    }
    refresh(dispatch) {
        if (dispatch) {
            this.dispatchChange();
        }
    }
    enable() {
        super.enable();
        this.toggleButton.setEnabled(this.isEnabled);
        if (this.uiProperties.hideToggleButton) {
            this.toggleButton.visible = this.isEnabled;
        }
        this.show();
    }
    disable() {
        super.disable();
        this.toggleButton.setEnabled(this.isEnabled);
        this.close();
    }
    createValueHolderMask() {
        this.createPanelSize();
        this.valueHolderMask = GraphicsUtil.createRectangle(new PIXI.Point(this.panelSize.x, this.panelSize.y), 0xff0000, 0.4);
    }
    // use both landscape and portrait properties
    createToggleButton() {
        this.toggleButton = new TitanButton(this.landscapeProperties.toggleButtonProperties, this.portraitProperties.toggleButtonProperties);
        this.toggleButton.name = "toggleButton";
        this.toggleButton.onClick(this.handleToggleButtonSelected, this);
        this.addChild(this.toggleButton);
    }
    handleToggleButtonSelected() {
        super.handleToggleButtonSelected();
        this.addChild(this.panel);
        this.panel.eventMode = "auto";
        this.toggleButton.isSelected() ? this.open() : this.close();
    }
    handleNewStakeButtonSelected(button) {
        const newIndex = button.getData();
        const oldIndex = this.stakeSelectorData.getIndex();
        const difference = newIndex - oldIndex;
        if (difference > 0) {
            this.dispatchCore(SlingoEvent.STAKE_SELECTED_INCREMENT);
        }
        else if (difference < 0) {
            this.dispatchCore(SlingoEvent.STAKE_SELECTED_DECREMENT);
        }
        else {
            this.dispatchCore(SlingoEvent.STAKE_SELECTED_SAME);
        }
        super.handleNewStakeButtonSelected(button);
    }
    handleCloseToggleComplete() {
        this.panel.eventMode = "none";
        this.removeChild(this.panel);
        this.removePanelMask();
        if (!this.isEnabled) {
            if (this.uiProperties.hideToggleButton) {
                this.toggleButton.visible = this.isEnabled;
            }
        }
    }
    handleResize(event) {
        if (this.renderer.isLandscape()) {
            this.anchorRight(this.toggleButton, this.uiProperties.toggleButtonProperties, this.renderer.getSafeTransform().x / 10 * 8);
        }
        else {
            this.anchorTop(this.toggleButton, this.uiProperties.toggleButtonProperties, 0);
        }
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.uiProperties = this.uiProperties;
        this.resizeView(this.panel, this.uiProperties.panelProperties);
    }
}
//# sourceMappingURL=StakeSelector.js.map